/**
 * Fallback handler: a recording the server could not read.
 *
 * Fires on `server.error` / `validation_failed`, which on the audio path
 * means the gateway could not base64-decode the frame this client sent.
 * That is our encoder's fault, not the visitor's and not their device's,
 * so the copy neither apologises for them nor asks them to change
 * anything about how they spoke.
 *
 * Carries the `stt-ws-fail` kind rather than introducing one of its own.
 * The kind is the precedence key in `bannerPrecedence.ts`, and this
 * belongs at exactly the rank that failure already holds: input-side,
 * above a reply that will not speak, below a spent balance. A new kind
 * would need a new rank and would invite the ranking table to grow a row
 * per error code rather than per severity.
 */

import type { FallbackBanner } from "@/voice/types";

export function makeAudioRejectedBanner(onRetry: () => void): FallbackBanner {
  return {
    kind: "stt-ws-fail",
    message: "That recording couldn't be read. You can keep going by typing.",
    retryAction: onRetry,
    retryLabel: "Try again",
  };
}
